import {MapAnnouncement} from "./MapAnnouncement";
import {MapUpdate} from "./MapUpdate";
import {UserFocus} from "./UserFocus";
import {UserOutFocus} from "./UserOutFocus";
import {UserEnter} from "./UserEnter";
import {UserLeave} from "./UserLeave";

export type MapAnnouncementType = 'update' | 'focus' | 'out_focus' | 'enter' | 'leave';

export function deserializeMapAnnouncement(map_id: string, type: string, value: string): MapAnnouncement {

    const value_obj = JSON.parse(value);

    if (type === 'update') {
        return MapUpdate.fromRaw(map_id, value_obj);
    } else if (type === 'focus') {
        return UserFocus.fromRaw(map_id, value_obj);
    } else if (type === 'out_focus') {
        return UserOutFocus.fromRaw(map_id, value_obj);
    } else if (type === 'enter') {
        return UserEnter.fromRaw(map_id, value_obj);
    } else if (type === 'leave') {
        return UserLeave.fromRaw(map_id, value_obj);
    }

    throw new Error(`unknown announcement type: ${type}`);
}

export const MapAnnouncementTypeGuard = {
    isUpdate(announcement: MapAnnouncement): announcement is MapUpdate {
        return announcement.Type === 'update';
    },
    isFocus(announcement: MapAnnouncement): announcement is UserFocus {
        return announcement.Type === 'focus';
    },
    isOutFocus(announcement: MapAnnouncement): announcement is UserOutFocus {
        return announcement.Type === 'out_focus';
    },
    isEnter(announcement: MapAnnouncement): announcement is UserOutFocus {
        return announcement.Type === 'enter';
    },
    isLeave(announcement: MapAnnouncement): announcement is UserOutFocus {
        return announcement.Type === 'leave';
    }
}
